import { getPlatformClient } from 'shared/utils/platform-utils';
import { AethonQRPDFTemplate } from './aethon/aethon-qr-pdf-template';
import { LevelWorksQRPDFTemplate } from './level-works/level-works-qr-pdf-template';
import { HollandworxQRPDFTemplate } from './hollandworx/hollandworx-qr-pdf-template';
import { OpusQRPDFTemplate } from './opus/opus-qr-pdf-template';
import { Props } from './qr-code-pdf-template.types';

const TemplateMap = {
  AETHON: AethonQRPDFTemplate,
  HOLLANDWORX: HollandworxQRPDFTemplate,
  LEVELWORKS: LevelWorksQRPDFTemplate,
  OPUS: OpusQRPDFTemplate,
} as const;

export const QRCodePDFTemplate = ({ templateOptions, isOpusCompany }: Props) => {
  const client = getPlatformClient();
  const Template = isOpusCompany
    ? OpusQRPDFTemplate
    : TemplateMap[client as keyof typeof TemplateMap];

  if (!Template) {
    throw new Error(`No QR PDF template defined for client: ${client}`);
  }

  return <Template {...templateOptions} />;
};
